// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";

@Component({
  name: "EconicProductSiegel",
  mixins: [template],
})
export default class EconicProductSiegel extends Vue {
  @Prop()
  siegelNummer!: string;

  @Prop()
  provedBy!: string;
}
